import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import content from "../../../assets/content.svg";
import { Navigation } from '../../home/navigation/navigation';
import { assetsMap, imageInitializer } from "../../../model/assets";
import { useEffect, useState } from "react";

const SkillRenderer = ({ name, image, example }) => {
    const [assets, setAssets] = useState(assetsMap);
    const connector = {
        layout: "link_this",
        experimentations: "miserecord",
        packaging: "theDock",
        brandIdentity: "link_here"
    }
    useEffect(() => {
        let timeout = imageInitializer(setAssets);
        return () => {
            clearTimeout(timeout);
        }
    }, [assets, setAssets]);
    return (
        <div className={`view ${ name } standalone`}>
           <Navigation/>
            <div className="action top left align-center">
                <Link to={"../services"}><button className="reveal reveal-area action round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
                <Link to={"../portfolio"}><button className="reveal reveal-area round action align-center"><img draggable="false" alt="" width="30" height="30" src={ content }/><span className="optimizeSmall"><FormattedMessage id="titlePortfolio"/></span></button></Link>
            </div>
            <div className="serviceLayout">
                <div className="imgFull" style={{backgroundImage: `url(${assetsMap[image].file})`}}/>
                <div>
                    <h2><FormattedMessage id={ name }/></h2>
                    <p><FormattedMessage id={`text_${ name }`} values={{rtn: <br/>}}/></p>
                    {
                        example && <>
                            <h3><FormattedMessage id="text_example_title"/></h3>
                            <p><FormattedMessage id={`text_${ name }_example`} values={{rtn: <br/>, link: <Link to={`../collections/view?id=${ example }&ctx=${ name }`}><FormattedMessage id={connector[name]}/></Link>}}/></p>
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default SkillRenderer;